import * as z from "zod";
import { PrintQueueStatusSchema } from "./watch-print-queue";

export const dismissPrintJobs = {
  name: "dismissPrintJobs" as const,
  input: z.object({ printJobs: z.array(z.string()) }),
  output: PrintQueueStatusSchema,
};

export type DismissPrintJobsInput = z.infer<typeof dismissPrintJobs.input>;
